/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import { CompanyObject, CompanyOnServerObject } from '../../types/Company';

export function toLocalObject(context: CompanyOnServerObject) {
  let localObject: CompanyObject = {};
  if (context) {
    localObject = {
      ...context,
      hr_id: context.id,
      punti_forza: context.punti_forza?.map((x) => x.punto_forza),
      mansioni_preferite: context.mansioni_preferite?.map((x) => x.mansione_preferita),
    };
  } else {
    console.warn('Trying to convert empty server company Obj');
  }

  return localObject;
}

export function toServerObject(context: CompanyObject) {
  const serverObject: CompanyOnServerObject = {
    ...context,
    id: context.hr_id,
    punti_forza: context.punti_forza?.map((x) => ({ punto_forza: x })),
    mansioni_preferite: context.mansioni_preferite?.map((x) => ({ mansione_preferita: x })),
    logo: context.logo
  };
  return serverObject;
}